import { createSelector } from '@reduxjs/toolkit';

import { selectManagedExpertById } from 'FRONTEND/reducers/expertSlice';
import { FormTypes } from 'FRONTEND/utils/constants';
import { getDurationSettingKey } from 'FRONTEND/utils/stringFormatting';

export const selectAdditionalSelectedExpertIds = (state) => state.booking.additionalSelectedExpertIdList;
export const selectSelectedExpertId = (state) => state.booking.selectedExpertId;
export const selectSelectedType = (state) => state.booking.selectedType;

export const selectExpertDefaultDuration = createSelector(
  (state) => selectManagedExpertById(state, state.booking.selectedExpertId),
  (state) => state.booking.defaultDuration,
  (state) => state.booking.selectedType,
  (selectedExpert, defaultDuration, selectedType) => {
    const expertDefaultDuration = selectedExpert?.[getDurationSettingKey(selectedType)];
    if (expertDefaultDuration) {
      return parseInt(expertDefaultDuration);
    }
    return defaultDuration;
  },
);

// A form counts as started once the user has set any field the form does not fill
// in for them. Entering a form pre-fills some of those fields, so they are not a
// signal of user input on their own:
//  - GIVEN_EXPERT_FORM comes from an entry point that already names the expert,
//    and its ExpertStep is locked (see getFormStepListAndIndex).
//  - the location, patient and unrestricted forms force their appointment type.
//  - the type step is auto-picked and locked whenever a single type is available.
export const selectIsFormStarted = createSelector(
  (state) => state.booking,
  ({
    formType,
    selectedExpertId,
    selectedType,
    availableTypeList,
    selectedLocationId,
    selectedPatientId,
    selectedSlot,
    desiredDateTime,
    additionalSelectedExpertIdList,
    isBooth,
    hasPayment,
    reason,
  }) => {
    const isExpertPreFilled = formType === FormTypes.GIVEN_EXPERT_FORM;
    const isTypePreFilled = formType === FormTypes.LOCATION_FORM ||
      formType === FormTypes.PATIENT_FORM ||
      formType === FormTypes.UNRESTRICTED_FORM ||
      availableTypeList?.length <= 1;

    return Boolean(
      (!isExpertPreFilled && selectedExpertId != null) ||
      (!isTypePreFilled && selectedType != null) ||
      selectedLocationId != null ||
      selectedPatientId != null ||
      selectedSlot != null ||
      desiredDateTime != null ||
      additionalSelectedExpertIdList?.length > 0 ||
      isBooth != null ||
      hasPayment != null ||
      reason,
    );
  },
);
